module.exports = __webpack_public_path__ + "img/Whiteninglogo.10ff32ab.png";